// Branding by hostname (2026-10-16): the Nursing Education dashboard is one app
// served on two sites. education.aren.com (+ staging) shows the Aren brand for
// demos; console.kabilah.com and every other host keep the Kabilah brand, so
// UNC users see no change until the December pilot switch. Anything not listed
// here falls back to Kabilah, the safe default for UNC.
import KabilahLogo from './images/KabilahLogo.JPG';
import KabilahLogoWhite from './images/KabilahLogoWhite.jpg';
import ArenLogo from './images/ArenLogo.png';

const AREN_HOSTS = ['education.aren.com', 'education-staging.aren.com'];

const BRANDS = {
  kabilah: {
    name: 'Kabilah',
    sidebarLogo: KabilahLogo,
    loginLogo: KabilahLogoWhite,
    copyright: '© 2026 Kabilah, Inc.',
    websiteUrl: 'https://www.kabilah.com',
    favicon: '/favicon.ico',
    touchIcon: '/logo192.png',
  },
  aren: {
    name: 'Aren',
    sidebarLogo: ArenLogo,
    loginLogo: ArenLogo,
    copyright: '© 2026 Kabilah Inc. DBA Aren',
    websiteUrl: 'https://www.aren.com',
    favicon: '/aren-favicon.png',
    touchIcon: '/aren-logo192.png',
  },
};

function pickBrand() {
  const host = window.location.hostname;
  if (AREN_HOSTS.includes(host)) return 'aren';
  // Local development only: http://localhost:3000/?brand=aren previews the Aren look.
  if (host === 'localhost' || host === '127.0.0.1') {
    const requested = new URLSearchParams(window.location.search).get('brand');
    if (requested && BRANDS[requested]) return requested;
  }
  return 'kabilah';
}

export const brandKey = pickBrand();
export const brand = BRANDS[brandKey];

// Browser tab title and icons follow the brand (index.html ships Kabilah's).
export function applyBrandToDocument() {
  document.title = brand.name;
  const setIcon = (rel, href) => {
    let link = document.querySelector(`link[rel="${rel}"]`);
    if (!link) {
      link = document.createElement('link');
      link.rel = rel;
      document.head.appendChild(link);
    }
    link.href = href;
  };
  setIcon('icon', brand.favicon);
  setIcon('apple-touch-icon', brand.touchIcon);
}
